import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function TruckIcon(props) {
  return (
    <SvgIcon viewBox="0 0 21 22" {...props}>
      <title>Delivery Truck</title>
      <path
        d="M16.88 12.494c1.126 0 2.04.914 2.04 2.04 0 1.128-.914 2.041-2.04 2.041-1.128 0-2.042-.913-2.042-2.04s.914-2.041 2.041-2.041zM3.156 15.043c-.367-1.52.968-2.855 2.488-2.488.714.173 1.299.758 1.471 1.473.366 1.519-.968 2.852-2.487 2.486-.714-.172-1.3-.757-1.472-1.471zm9.384-10.624c2.521 0 3.291 1.642 3.291 4.204 3.508 0 5.15.648 5.15 1.774 0 .915.013 2.569.018 3.157 0 .12-.098.214-.218.214h-1.13c0-.974-.807-2.537-2.83-2.537-1.703 0-3.012 1.491-3.012 3.3l-5.463.004s-.013-3.279-3.21-3.279c-2.416 0-3.061 2.146-3.066 3.268H0l.064-6.577c.018-1.908 1.562-3.448 3.468-3.462h.038c.3-.003 2.324-.022 4.44-.04l.53-.004.527-.004c1.138-.008 2.222-.015 2.993-.017z"
        transform="translate(-966.000000, -25.000000) translate(950.000000, 14.500000) translate(15.999580, 11.000000)"
      />
    </SvgIcon>
  );
}

export default TruckIcon;
